const ListSizeFormatter = ({ value }) => {
  return value?.length;
};

export default ListSizeFormatter;
